import axios from '../utils/axios';

// 🔐 Login API
export const loginUser = async (data) => {
  const response = await axios.post('/api/Auth/Login', data);
  //console.log(response);
  return response.data; // should include { user, token }
};

// 🆕 Register API
export const registerUser = async (data) => {
  const response = await axios.post('/api/User/CreateCustomer', data);
  return response.data; // should include { user, token }
};

// Register Seller API
export const registerSeller = async (data) => {
  const response = await axios.post('/api/User/CreateSeller', data);
  return response.data; // should include { user, token }
};

// 🧾 Fetch current user (by decoded JWT userId)
export const getCurrentUser = async (userId) => {
  const response = await axios.get('/api/User/GetSingle', {
    params: { userId }
  });
  return response.data;
};

// 🏢 Get company info by email
export const getCompanyByEmail = async (email) => {
  const response = await axios.get('/api/Company/GetByEmail', {
    params: { email }
  });
  return response.data;
};

export const forgotPassword = async (email) => {
  const response = await axios.post('/api/User/ForgotPassword', {
     email 
  });
  return response.data;
};

// 🔁 Logout (client-side only)
export const logoutUser = () => {
  localStorage.removeItem('serviceToken');
  delete axios.defaults.headers.common['Authorization'];
};

// 🔒 Reset password
export const resetPassword = async (token, username, password, confirmPassword) => {
  const response = await axios.post('/api/User/ResetPassword', {
    token,
    username,
    newPassword: password,
    newPasswordConfirm: confirmPassword
  });
  return response.data;
};

// ✅ Confirm email
export const confirmEmail = async (token, username) => {
  const response = await axios.put('/api/customer/Account/ConfirmEmail', null, {
    params: {
      token,
      userName: username
    }
  });
  return response.data;
};

// ✅ Confirm email
export const loginGoogle = async (token) => {
  const response = await axios.post('/api/Auth/GoogleSignIn', null, {
    params: {
      IdToken: token
    }
  });
  return response.data;
};
